module.exports = __webpack_public_path__ + "fonts/noto-sans-v7-latin-regular4bdffaaa646258ee12f4303664e3c806.woff";